import { EnhancedToken } from "../../types/Token";
import AuthorizationRenewer, { IAuthorizationRenewerProps } from "../Components/AuthorizationRenewer";
import usePutToken from "../hooks/usePutToken";
import AppContextValueProvider from "./AppContextValueProvider";

const AppContextAuthorizationRenewer: React.FC<Pick<IAuthorizationRenewerProps, "router">> = AppContextValueProvider<
  Omit<IAuthorizationRenewerProps, "router">,
  IAuthorizationRenewerProps
>({
  Component: AuthorizationRenewer,
  map: ({ patient, refreshTokenCState, sessionKeyCState, setTokenCState }) => ({
    endedSessionProps: { patientName: patient.displayFirstName, sessionKey: sessionKeyCState },
    value: refreshTokenCState || null,
    onChange: t => setTokenCState(t ? new EnhancedToken(t) : undefined),
    usePutToken
  })
});

export default AppContextAuthorizationRenewer;
